const getCookie = (name) => {
  var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
};

const setCookie = (name, value, days = 1) => {
  var d = new Date();
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
  document.cookie = name + '=' + value + ';path=/;expires=' + d.toGMTString();
};

const deleteCookie = (name) => {
  setCookie(name, '', -1);
};

const initCookieNotice = () => {
  var notice = document.getElementById('cookie-notice');
  var accept = document.getElementsByClassName('cookie-notice-accept');
  var windowEl = $(window);
  if (!notice) {
    return;
  }
  var hideCookieNotice = () => {
    notice.style.display = 'none';
  };
  var showCookieNotice = () => {
    notice.removeAttribute('style');
  };

  if (getCookie('acceptCookieNotice')) {
    hideCookieNotice();
    return;
  }

  document.addEventListener('click', function (event) {
    if (!event.target.matches('.cookie-notice-accept')) return;
    event.preventDefault();
    hideCookieNotice();
    setCookie('acceptCookieNotice', true);
    windowEl.off('scroll');
  });

  windowEl.on('scroll', function () {
    if ($(this).scrollTop() > 10) {
      hideCookieNotice();
    } else {
      showCookieNotice();
    }
  });
};

module.exports = { getCookie, setCookie, deleteCookie, initCookieNotice };
